module.exports = __webpack_public_path__ + "static/team-12-493b5e553e2e1871a35d411b299686dd.jpg";